// extracted by mini-css-extract-plugin
export default {"video":"VideoBackground_video__TN3s+"};